<template>
  <div>
    <div class="d-flex justify-space-between">
      <div class="text-h4 mb-0 d-flex align-center">
        Completed Print Orders
        <v-btn
          outlined
          small
          icon
          class="ml-3"
          min-width="20"
          :loading="loading"
          @click="loadData"
        >
          <v-icon small> refresh </v-icon>
        </v-btn>
      </div>
    </div>
    <PrintList
      :loading="loading"
      :data="completed"
      title="Completed"
      completed
    />
  </div>
</template>

<script>
import PrintList from '@/components/orders/print/List';
import { mapGetters } from 'vuex';

export default {
  name: 'OrdersCompleted',

  components: { PrintList },

  data() {
    return { loading: false, submitting: false };
  },

  computed: {
    ...mapGetters({
      completed: 'orders/completed'
    })
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('orders/getCompleted')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
